import { SafeHtml } from '@angular/platform-browser';
import { BaseObject } from '../../public_api';
import { ResultItem } from './resultItem.interface';
import { ResultItemType } from './resultItemType.enum';

export class VolcanoResultItem extends BaseObject implements ResultItem {
  public readonly type = ResultItemType.VOLCANO;
  public readonly isReady = true;
  public readonly isError = false;

  public readonly name: string;
  public readonly sourceName = 'SI GVP';
  public readonly iconHtml: SafeHtml;
  public readonly subTitle: string;
  public readonly imageUrl: string;
  public readonly summary: string;
  public readonly volcanoLink: string;

  private properties: Record<string, unknown>;

  protected constructor(sourceObject: Record<string, unknown>) {
    super(sourceObject);

    this.properties = this._getValue('properties') as Record<string, unknown>;
    this.name = this._getString('VolcanoName', this.properties);
    this.subTitle = this._getString('VolcanoType', this.properties);
    this.imageUrl = this._getString('ImageLink', this.properties).replace('mid', 'full');
    this.summary = this._getString('Background', this.properties);
    this.volcanoLink = Object.keys(europeanCatalogueVolcanoes).find((key: string) => {
      return this.name === europeanCatalogueVolcanoes[key];
    });
  }

   
  public populate(): void {}
}

const europeanCatalogueVolcanoes = {
  CDP: '',
  MAY: 'Mayotte Island',
  PEL: 'Pelée',
  PLF: 'Fournaise, Piton de la',
  SDG: 'Soufrière Guadeloupe',
  SAN: 'Santorini',
  ASK: 'Askja',
  BAR: 'Bárdarbunga',
  BRE: 'Brennisteinsfjöll',
  ELD: '',
  ESJ: 'Esjufjöll',
  EYJ: 'Eyjafjallajökull',
  FRE: 'Fremrinamur',
  GRN: 'Grímsnes',
  GRV: 'Grímsvötn',
  HEI: '',
  HEK: 'Hekla',
  HEL: 'Helgrindur',
  HEN: 'Hengill',
  HOF: 'Hofsjökull',
  HRO: 'Hrómundartindur',
  KAT: 'Katla',
  KRA: 'Krafla',
  KRI: 'Krísuvík',
  KVE: 'Kverkfjöll',
  LAN: '',
  LJO: 'Ljósufjöll',
  ORA: 'Öraefajökull',
  PRE: 'Prestahnukur',
  REY: 'Reykjanes',
  SNF: '',
  SNJ: 'Snaefellsjökull',
  TIN: 'Tindfjallajökull',
  TOR: 'Torfajökull',
  TUN: 'Tungnafellsjökull',
  VES: 'Vestmannaeyjar',
  TEY: '',
  THO: '',
  ETN: 'Etna',
  STR: 'Stromboli',
  VEV: 'Vesuvius',
  BEE: 'Jan Mayen',
  FOG: 'Agua de Pau',
  SCI: 'Sete Cidades',
  GVF: 'Olot Volcanic Field',
  TPV: 'Tenerife',
  ASC: 'Ascensión',
  TDC: 'Tristan da Cunha',
};
